module.exports = __webpack_public_path__ + "static/media/role.5fb1692e.svg";